import { authImage } from "assets/images";
import useButtonLoader from "hooks/useButtonLoader";
import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resendOtp, verifyOtpApi } from "services/auth";
import { setPersonalInfo } from "store/slices/userDataStore";
import { toastMessage } from "utils/toastMessage";

const OTPComponents = ({ setSteps, data, setData }) => {
  // console.log("data:-------->", data);
  const [buttonLoader, setButtonLoader] = useButtonLoader("Verify");
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const [resendDisabled, setResendDisabled] = useState(true);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(59);
  const dispatch = useDispatch();

  const verifyOtpHandler = async () => {
    try {
      if (otp.length >= 4) {
        setButtonLoader(true);
        const response = await verifyOtpApi({
          // ...data,
          otp: otp,
          // email: "sindhi@yopmail.com",
          email: data.email,
          otpType: "FORGOT",
        });

        console.log("res:------------>", data);
        if (response.data.status || response.data.code === 200) {
          toastMessage(
            response?.data?.message,
            "success",
            "Otp Verified Successfully "
          );

          localStorage.setItem(
            "resetPassword_token",
            JSON.stringify(response.data?.data?.token)
          );

          setData({
            email: response.data?.data?.admin?.email,
            otp: otp,
          });

          setSteps(5);
        } else {
          toastMessage(response?.data?.message, "error", "loginToDashboard");
        }
      } else {
        toastMessage("Invalid OTp", "error", "invalidOtp");
      }
    } catch (e) {
      console.log("error:", e.message);
    } finally {
      setButtonLoader(false);
    }
  };
  const resendOtpHandler = async () => {
    try {
      setResendDisabled(true);
      setMinutes(0);
      setSeconds(59);
      const reqData = {
        email: data?.email,
      };
      const res = await resendOtp(reqData);
      if (res?.data?.status === 200) {
        toastMessage(res?.data?.message, "success", "OtpSend");
      } else {
        toastMessage(res?.data?.message, "error", "OtpSend");
      }
    } catch (e) {
      console.log("error:", e.message);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
          setResendDisabled(false);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [minutes, seconds]);

  return (
    <>
      <div className="auth_section">
        <div className="image_section">
          <img src={authImage} alt="" />
        </div>
        <form className="otp_section">
          <div className="form_title">
            <h3>Verify OTP</h3>
            <p>Please enter the OTP SENT to {` ${data?.email}`}</p>
          </div>

          <div className="content">
            <div className="otp_wrap">
              <OTPInput
                inputStyle={"form-control input"}
                inputType="tel"
                value={otp}
                onChange={setOtp}
                numInputs={4}
                renderInput={(props) => <input {...props} />}
              />
            </div>

            <div className="resend_button">
              <p>
                {/* Resend OTP in <b>00:56</b> */}
                Resend OTP in{" "}
                <b>
                  {minutes < 10 ? `0${minutes}` : minutes}:
                  {seconds < 10 ? `0${seconds}` : seconds}
                </b>
              </p>
              <button
                type="button"
                disabled={resendDisabled}
                onClick={resendOtpHandler}
              >
                Resend OTP
              </button>
            </div>

            {/* {seconds > 0 || minutes > 0 ? (
            <p>
              Time Remaining: 
            </p>
          ) : (
            <p>Didn't recieve code?</p>
          )} */}
            <div className="button_wrap">
              <button
                type="button"
                className="button"
                ref={buttonLoader}
                onClick={verifyOtpHandler}
              >
                Verify
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
export default OTPComponents;
